module.exports = __webpack_public_path__ + "img/hazmat.1f957415.png";